import { useTranslation } from "react-i18next";
import { Form, FormButton, Input, LabelField } from "components";
import { IPaymentV2ScreenRouteProps } from "../../PaymentScreen";
import { useRouter } from "hooks";

import styles from "./VoucherForm.module.scss";

export const VOUCHER_FIELD_NAME = "voucher_code";

export interface VoucherFormValues {
  voucher_code?: string;
}

interface VoucherFormProps {
  isLoading: boolean;
  onSubmit: (values: VoucherFormValues) => void;
}

export const VoucherForm = ({ isLoading, onSubmit }: VoucherFormProps) => {
  const { t } = useTranslation("translations");
  const router = useRouter();
  const query = router.query as IPaymentV2ScreenRouteProps;
  const voucherCode = query.voucherCode;

  return (
    <Form
      className={styles.form}
      initialValues={{ [VOUCHER_FIELD_NAME]: voucherCode }}
      onFinish={onSubmit}
    >
      <LabelField
        name={VOUCHER_FIELD_NAME}
        label={t("web_offer_voucher_input_label")}
      >
        <Input
          placeholder={t("web_offer_voucher_input_placeholder")}
          className={styles.input}
        />
      </LabelField>

      <FormButton
        nonEmptyFields={{
          requiredFields: [VOUCHER_FIELD_NAME],
          autoCompleted: false,
        }}
        disabled={isLoading}
        loading={isLoading}
        size="large"
        className={styles.submit}
      >
        {t("web_offer_voucher_redeem")}
      </FormButton>
    </Form>
  );
};

export default VoucherForm;
